import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';

import { VehicleCategorySection } from './VehicleCategorySection';
import { VehicleMakeSection } from './VehicleMakeSection';
import { VehicleModelSection } from './VehicleModelSection';

/**
 * VehicleInformationSection component that provides vehicle information
 * filtering options wrapped in an accordion
 */
export function VehicleInformationSection() {
	return (
		<AccordionSection title='Vehicle information'>
			<Stack itemsSpacing='24'>
				<VehicleMakeSection />
				<VehicleCategorySection />
				<VehicleModelSection />
			</Stack>
		</AccordionSection>
	);
}
